module.exports = __webpack_public_path__ + "img/07.a4bdca26.png";